// Réplicas fieles de las pantallas de PCM para la landing (datos de ejemplo).
// Mismo estilo que la app: tema Notion (blanco, barra lateral #F5F5F5, texto #37352F,
// íconos en oro viejo) y el mismo menú lateral. Octubre 2026.
import React, { useEffect, useState } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SubjectIcon from '@mui/icons-material/Subject';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SavingsIcon from '@mui/icons-material/Savings';
import PaymentsIcon from '@mui/icons-material/Payments';
import RuleIcon from '@mui/icons-material/Rule';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import MicIcon from '@mui/icons-material/Mic';
import PieChartIcon from '@mui/icons-material/PieChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CategoryIcon from '@mui/icons-material/Category';
import HomeIcon from '@mui/icons-material/Home';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import goldColors from '../themes/goldColors';

const GOLD = goldColors.main;

const CSS = `
.px-wrap{container-type:inline-size;container-name:px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;color:#37352F;text-align:left}
.px-tabs{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 12px}
.px-tab{border:1px solid rgba(255,255,255,.3);background:transparent;color:#fff;border-radius:999px;padding:5px 12px;font-size:12.5px;cursor:pointer;font-family:inherit;display:inline-flex;align-items:center;gap:6px}
.px-tab.on{background:${GOLD};border-color:${GOLD};color:#fff}
.px-light .px-tab{border-color:#E0E0E0;color:#37352F}
.px-light .px-tab.on{color:#fff}
.px-win{background:#fff;border-radius:10px;overflow:hidden;box-shadow:0 24px 60px -24px rgba(0,0,0,.45),0 1px 3px rgba(0,0,0,.12);border:1px solid #E0E0E0}
.px-bar{display:flex;align-items:center;gap:10px;padding:8px 12px;background:#EEEEEE;border-bottom:1px solid #E0E0E0}
.px-dots{display:flex;gap:5px}.px-dots i{width:9px;height:9px;border-radius:50%;background:#D0D0D0;display:block}
.px-url{background:#fff;border-radius:6px;padding:2px 10px;font-size:10.5px;color:#6B6B6B;font-family:ui-monospace,Menlo,monospace}
.px-app{display:grid;grid-template-columns:150px 1fr;height:430px;overflow:hidden}
.px-side{background:#F5F5F5;padding:10px 6px;font-size:10.5px;overflow:hidden}
.px-brand{display:flex;align-items:center;gap:6px;font-weight:600;font-size:12px;padding:2px 6px 8px}
.px-brand b{width:18px;height:18px;border-radius:4px;background:${GOLD};color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:10px}
.px-sec{font-size:9.5px;color:#9E9E9E;font-weight:600;padding:8px 6px 3px;text-transform:none}
.px-it{display:flex;align-items:center;gap:6px;padding:3px 6px;border-radius:4px;color:#37352F;white-space:nowrap}
.px-it svg{font-size:13px !important}
.px-it.on{background:rgba(0,0,0,.08);font-weight:500}
.px-badge{margin-left:auto;background:#E03E3E;color:#fff;border-radius:9px;font-size:8.5px;padding:0 4px;line-height:14px}
.px-main{padding:12px 14px;min-width:0;background:#fff;overflow:hidden;position:relative}
.px-main::after{content:'';position:absolute;left:0;right:0;bottom:0;height:28px;background:linear-gradient(rgba(255,255,255,0),#fff)}
.px-h{font-size:17px;font-weight:600;margin:0 0 2px}
.px-sub{font-size:11px;color:#6B6B6B;margin:0 0 12px}
.px-row{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.px-card{background:#fff;border-radius:6px;box-shadow:0 1px 2px rgba(0,0,0,.06),0 1px 3px rgba(0,0,0,.1);padding:10px 12px}
.px-card+.px-card{margin-top:8px}
.px-row .px-card+.px-card{margin-top:0}
.px-ct{font-size:11.5px;font-weight:600;margin:0 0 6px;display:flex;align-items:center;gap:6px}
.px-big{font-size:18px;font-weight:600}
.px-sm{font-size:10.5px;color:#6B6B6B}
.px-li{display:flex;justify-content:space-between;font-size:11px;padding:4px 0;border-top:1px solid #EEEEEE}
.px-num{font-variant-numeric:tabular-nums;white-space:nowrap}
.px-g{color:#0F7B6C}.px-r{color:#E03E3E}.px-a{color:#D9730D}
.px-alert{border-left:3px solid #D9730D;background:#FBF3DB}
.px-btns{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px}
.px-btn{font-size:10.5px;border-radius:4px;padding:4px 9px;border:1px solid #E0E0E0;background:#fff;color:#37352F;font-weight:500}
.px-btn.dk{background:#2E2E2E;border-color:#2E2E2E;color:#fff}
.px-btn.gd{background:${GOLD};border-color:${GOLD};color:#fff}
.px-track{height:6px;background:#EEEEEE;border-radius:3px;overflow:hidden;margin:3px 0 6px}
.px-track i{display:block;height:100%;border-radius:3px}
.px-cal{display:grid;grid-template-columns:repeat(7,1fr);border-top:1px solid #E0E0E0;border-left:1px solid #E0E0E0}
.px-cal div{border-right:1px solid #E0E0E0;border-bottom:1px solid #E0E0E0;min-height:44px;padding:3px 4px;font-size:9px}
.px-cal .hd{min-height:0;font-weight:600;color:#6B6B6B;text-align:center;background:#FAFAFA}
.px-cal .d{font-weight:600;color:#37352F;font-size:9.5px}
.px-cal .bal{color:#37352F;font-weight:600;display:block;margin-top:1px}
.px-cal .low{background:#FBE4E4}
.px-cal .today{background:#F5EFD4}
.px-seg{display:inline-flex;border:1px solid #E0E0E0;border-radius:4px;overflow:hidden;font-size:10px}
.px-seg span{padding:2px 8px}.px-seg span.on{background:#2E2E2E;color:#fff}
.px-drop{border:1.5px dashed #BDBDBD;border-radius:6px;padding:10px;text-align:center;font-size:11px;color:#6B6B6B;background:#FAFAFA}
.px-file{display:inline-block;background:#fff;border:1px solid #E0E0E0;border-radius:4px;padding:2px 8px;margin:4px 3px 0;font-size:10.5px;color:#37352F}
.px-tbl{width:100%;border-collapse:collapse;font-size:10.5px}
.px-tbl th{text-align:left;color:#6B6B6B;font-weight:500;padding:4px 5px;border-bottom:1px solid #E0E0E0}
.px-tbl td{padding:5px;border-bottom:1px solid #EEEEEE}
.px-chip{display:inline-block;border-radius:3px;padding:0 6px;font-size:9.5px;line-height:16px;background:#EEEEEE;color:#37352F;white-space:nowrap}
.px-chip.b{background:#DDEBF1;color:#0B6E99}.px-chip.y{background:#FBF3DB;color:#9A6A12}.px-chip.p{background:#EAE4F2;color:#6940A5}
.px-kp{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:10px}
.px-kp .px-card{margin:0;padding:8px 10px}
.px-ai{background:#F5EFD4;border-radius:6px;padding:8px 10px;font-size:11px;margin-top:10px}
.px-q{background:#F5F5F5;border-radius:6px;padding:7px 10px;font-size:11.5px;margin-bottom:10px;display:flex;gap:6px;align-items:center}
.px-bars{display:flex;align-items:flex-end;gap:8px;height:110px;padding:0 4px;border-bottom:1px solid #E0E0E0}
.px-bars div{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;height:100%;font-size:9px;color:#6B6B6B}
.px-bars i{display:block;width:70%;border-radius:3px 3px 0 0;background:#667EEA;margin-bottom:2px}
.px-bars i.hl{background:${GOLD}}
.px-bl{display:flex;gap:8px;padding:3px 4px 0}.px-bl span{flex:1;text-align:center;font-size:9px;color:#6B6B6B}
.px-wa{background:#E5DDD5;padding:12px;height:388px;overflow:hidden;display:flex;flex-direction:column;gap:7px}
.px-wah{display:flex;align-items:center;gap:8px;background:#075E54;color:#fff;padding:8px 12px;font-size:12px;font-weight:600}
.px-msg{max-width:78%;padding:6px 9px;border-radius:7px;font-size:11.5px;line-height:1.4;background:#fff;box-shadow:0 1px .5px rgba(0,0,0,.13)}
.px-msg.me{align-self:flex-end;background:#DCF8C6}
.px-msg small{display:block;text-align:right;color:#999;font-size:9px;margin-top:2px}
.px-rcpt{background:#fff;border:1px solid #ddd;border-radius:4px;padding:6px 8px;font-family:ui-monospace,Menlo,monospace;font-size:10px;margin-bottom:4px}
.px-fade{animation:pxIn .45s ease}
@keyframes pxIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
@container px (max-width:520px){.px-app{grid-template-columns:1fr;height:470px}.px-side{display:none}.px-kp{grid-template-columns:1fr 1fr}.px-wa{height:434px}}
@container px (max-width:380px){.px-row{grid-template-columns:1fr}.px-row .px-card+.px-card{margin-top:8px}}
.pxf{font-family:inherit}
.pxf-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:18px}
.pxf-card{background:#fff;border:1px solid #E0E0E0;border-radius:8px;padding:18px 18px 14px;text-align:left}
.pxf-card h3{display:flex;align-items:center;gap:8px;font-size:16px;font-weight:600;margin:0 0 10px;color:#37352F}
.pxf-card h3 svg{color:${GOLD}}
.pxf-card ul{list-style:none;padding:0;margin:0}
.pxf-card li{font-size:13.5px;line-height:1.45;color:#37352F;padding:6px 0;border-top:1px solid #F0F0F0}
.pxf-card li b{font-weight:600}
.pxf-new{display:inline-block;background:${goldColors.pale};color:${goldColors.dark};font-size:10.5px;font-weight:600;border-radius:3px;padding:0 6px;margin-left:6px;vertical-align:1px}
@media (max-width:900px){.pxf-grid{grid-template-columns:1fr 1fr}}
@media (max-width:600px){.pxf-grid{grid-template-columns:1fr}}
`;

const tr = (language, es, en) => (language === 'es' ? es : en);

function Sidebar({ language, active }) {
  const L = (es, en) => tr(language, es, en);
  const groups = [
    [null, [['home', HomeIcon, L('Inicio', 'Home')]]],
    [L('Cómo voy', 'How am I doing'), [
      ['dashboard', DashboardIcon, L('Tablero', 'Dashboard')],
      ['calendar', CalendarMonthIcon, L('Calendario', 'Calendar')],
      ['reports', SubjectIcon, L('Informes', 'Reports')],
    ]],
    [L('Mi dinero', 'My money'), [
      ['accounts', AccountBalanceWalletIcon, L('Cuentas', 'Accounts')],
      ['debts', SavingsIcon, L('Deuda', 'Debt')],
    ]],
    [L('Movimientos', 'Activity'), [
      ['transactions', PaymentsIcon, L('Transacciones', 'Transactions')],
      ['revision', RuleIcon, L('Revisión pendiente', 'Pending review')],
      ['conciliacion', FactCheckIcon, L('Conciliación', 'Reconciliation')],
      ['voice', MicIcon, L('Voz', 'Voice')],
    ]],
    [L('Planificación', 'Planning'), [
      ['budgets', PieChartIcon, L('Presupuestos', 'Budgets')],
      ['recurring', TrendingUpIcon, L('Recurrentes', 'Recurring')],
      ['categories', CategoryIcon, L('Categorías', 'Categories')],
    ]],
  ];
  return (
    <div className="px-side">
      <div className="px-brand"><b>P</b>PCM</div>
      {groups.map(([title, items], gi) => (
        <div key={gi}>
          {title && <div className="px-sec">{title}</div>}
          {items.map(([key, Icon, label]) => (
            <div key={key} className={'px-it' + (key === active ? ' on' : '')}>
              <Icon style={{ color: GOLD }} />
              {label}
              {key === 'revision' && <span className="px-badge">18</span>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

function Bar({ pct, color }) {
  return <div className="px-track"><i style={{ width: Math.min(pct, 100) + '%', background: color }} /></div>;
}

function Dashboard({ language }) {
  const L = (es, en) => tr(language, es, en);
  const budget = [[L('Comida', 'Food'), 45, '#0F7B6C'], [L('Transporte', 'Transport'), 82, '#D9730D'], [L('Entretenimiento', 'Entertainment'), 100, '#E03E3E']];
  return (
    <>
      <p className="px-h">{L('Panel Financiero', 'Financial Dashboard')}</p>
      <p className="px-sub">{L('Todo tu dinero en una pantalla', 'All your money on one screen')}</p>
      <div className="px-row">
        <div className="px-card">
          <p className="px-ct">{L('Mis Cuentas Bancarias', 'My Bank Accounts')}</p>
          <div className="px-sm">{L('Balance en moneda nacional', 'Balance in local currency')}</div>
          <div className="px-big px-num">$12,450.00</div>
          <div className="px-li"><span>{L('Balance en dólares', 'In dollars')}</span><b className="px-num">US$ 1,320.00</b></div>
        </div>
        <div className="px-card">
          <p className="px-ct">{L('Mis Deudas', 'My Debts')}</p>
          <div className="px-sm">{L('Deuda en moneda nacional', 'Debt in local currency')}</div>
          <div className="px-big px-num px-r">$3,840.00</div>
          <div className="px-li"><span>{L('Pago mensual', 'Monthly payment')}</span><b className="px-num">$610.00</b></div>
        </div>
      </div>
      <div className="px-card px-alert" style={{ marginTop: 8 }}>
        <p className="px-ct px-a" style={{ margin: 0 }}>Visa Oro {L('vence en 3 días', 'is due in 3 days')} · <span className="px-num">$1,914.33</span></p>
        <div className="px-btns">
          <span className="px-btn dk">{L('Pagar 100% ahora', 'Pay 100% now')}</span>
          <span className="px-btn">{L('Financiar en 6 cuotas de $345 · interés $156', 'Finance in 6 payments of $345 · interest $156')}</span>
        </div>
      </div>
      <div className="px-card" style={{ marginTop: 8 }}>
        <p className="px-ct">{L('Presupuesto del mes', 'This month’s budget')}</p>
        {budget.map(([n, pct, color]) => (
          <div key={n}>
            <div className="px-li" style={{ borderTop: 0, padding: '2px 0 0' }}><span>{n}</span><span className="px-num" style={{ color }}>{pct}%</span></div>
            <Bar pct={pct} color={color} />
          </div>
        ))}
      </div>
    </>
  );
}

function Calendar({ language }) {
  const L = (es, en) => tr(language, es, en);
  const head = language === 'es' ? ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'] : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  // [día, ingreso, gasto, saldo fin de día, marca]
  const days = [
    [19, '', '-60', '7,410'], [20, '', '-85', '7,325'], [21, '', '', '7,325', 'today'], [22, '', '-185', '7,140'],
    [23, '', '-245', '6,895'], [24, '', '', '6,895'], [25, '+3,800', '-1,200', '9,495'],
    [26, '', '-310', '9,185'], [27, '', '-1,914', '7,271'], [28, '', '-6,031', '1,240', 'low'], [29, '', '-90', '1,150', 'low'],
    [30, '+550', '-40', '1,660'], [31, '', '-160', '1,500'], [1, '+3,800', '-950', '4,350'],
  ];
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <p className="px-h">{L('Calendario', 'Calendar')} · {L('Octubre 2026', 'October 2026')}</p>
        <span className="px-seg"><span className="on">{L('Moneda nacional', 'Local')}</span><span>{L('Dólares', 'Dollars')}</span></span>
      </div>
      <p className="px-sub">{L('Ingresos, gastos y saldo de fin de día, con tus recurrentes ya proyectados.', 'Income, expenses and end-of-day balance, with your recurring items already projected.')}</p>
      <div className="px-cal">
        {head.map((h) => <div key={h} className="hd">{h}</div>)}
        {days.map(([d, inc, exp, bal, mark]) => (
          <div key={d + '-' + bal} className={mark || ''}>
            <span className="d">{d}</span>
            {inc && <span className="px-g" style={{ display: 'block' }}>{inc}</span>}
            {exp && <span className="px-r" style={{ display: 'block' }}>{exp}</span>}
            <span className="bal">{bal}</span>
          </div>
        ))}
      </div>
      <div className="px-ai"><b>{L('Día más ajustado: 28 oct.', 'Tightest day: Oct 28.')}</b> {L('Tu saldo baja a $1,240 porque el pago de la tarjeta y el alquiler caen antes del sueldo. Lo ves con semanas de anticipación.', 'Your balance drops to $1,240 because the card payment and rent land before payday. You see it weeks ahead.')}</div>
    </>
  );
}

function Importer({ language }) {
  const L = (es, en) => tr(language, es, en);
  const rows = [
    ['03 oct', L('Supermercado Central', 'Central Market'), <span className="px-chip">{L('Mercado', 'Groceries')}</span>, '-284.50'],
    ['07 oct', L('Grifo Av. Primavera', 'Gas station'), <span className="px-chip">{L('Auto', 'Car')}</span>, '-180.00'],
    ['11 oct', L('Pago tarjeta desde Ahorros', 'Card payment from Savings'), <span className="px-chip b">{L('Pago de tarjeta · unido solo', 'Card payment · auto-matched')}</span>, '-1,914.33'],
    ['14 oct', L('Compra de dólares', 'Dollar purchase'), <span className="px-chip p">{L('Cambio de moneda · unido', 'FX exchange · matched')}</span>, '-1,500.00'],
    ['19 oct', L('Streaming mensual', 'Monthly streaming'), <span className="px-chip y">{L('¿Duplicado?', 'Duplicate?')}</span>, '-15.90'],
  ];
  return (
    <>
      <p className="px-h">{L('Revisión pendiente', 'Pending review')}</p>
      <p className="px-sub">{L('Sube el PDF, CSV o Excel del banco. La IA lee cada movimiento y lo clasifica; tú confirmas.', 'Upload the bank’s PDF, CSV or Excel. AI reads and classifies every line; you confirm.')}</p>
      <div className="px-drop">
        {L('Arrastra tus estados de cuenta', 'Drop your bank statements')}<br />
        <span className="px-file">📄 {L('Banco — Octubre.pdf', 'Bank — October.pdf')}</span>
        <span className="px-file">📄 Visa Oro — {L('Octubre.pdf', 'October.pdf')}</span>
      </div>
      <div className="px-card" style={{ marginTop: 10, padding: '6px 8px' }}>
        <table className="px-tbl">
          <thead><tr><th>{L('Fecha', 'Date')}</th><th>{L('Descripción', 'Description')}</th><th>{L('Categoría', 'Category')}</th><th style={{ textAlign: 'right' }}>{L('Monto', 'Amount')}</th></tr></thead>
          <tbody>
            {rows.map(([d, desc, cat, amt]) => (
              <tr key={d + desc}><td className="px-num">{d}</td><td>{desc}</td><td>{cat}</td><td className="px-num px-r" style={{ textAlign: 'right' }}>{amt}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-btns" style={{ alignItems: 'center' }}>
        <span className="px-btn gd">{L('Confirmar 18 movimientos', 'Confirm 18 transactions')}</span>
        <span className="px-sm">{L('1 pago de tarjeta y 1 cambio de moneda reconocidos · 1 posible duplicado', '1 card payment and 1 FX exchange recognized · 1 possible duplicate')}</span>
      </div>
    </>
  );
}

function Budget({ language }) {
  const L = (es, en) => tr(language, es, en);
  const cats = [[L('Mercado', 'Groceries'), 1180, 1400], [L('Restaurantes', 'Restaurants'), 840, 500], [L('Transporte', 'Transport'), 310, 600]];
  return (
    <>
      <p className="px-h">{L('Presupuestos', 'Budgets')} · {L('Octubre', 'October')}</p>
      <p className="px-sub">{L('Gastado contra presupuestado, con lo que queda y los días que faltan.', 'Spent vs. budgeted, with what’s left and the days to go.')}</p>
      <div className="px-kp">
        <div className="px-card"><div className="px-sm">{L('Gastado', 'Spent')}</div><div className="px-big px-num">$4,820</div></div>
        <div className="px-card"><div className="px-sm">{L('Presupuestado', 'Budgeted')}</div><div className="px-big px-num">$6,300</div></div>
        <div className="px-card"><div className="px-sm">{L('Te queda', 'Left')}</div><div className="px-big px-num px-g">$1,480</div></div>
        <div className="px-card"><div className="px-sm">{L('Quedan', 'Days left')}</div><div className="px-big px-num">12 {L('días', 'days')}</div></div>
      </div>
      <div className="px-card">
        {cats.map(([n, s, b]) => {
          const pct = Math.round((s / b) * 100);
          const color = pct >= 100 ? '#E03E3E' : pct >= 80 ? '#D9730D' : '#0F7B6C';
          return (
            <div key={n}>
              <div className="px-li" style={{ borderTop: 0 }}><span>{n}</span><span className="px-num">${s.toLocaleString('en-US')} / ${b.toLocaleString('en-US')}</span></div>
              <Bar pct={pct} color={color} />
            </div>
          );
        })}
      </div>
      <div className="px-ai">
        <b><AutoAwesomeIcon style={{ fontSize: 13, color: GOLD, verticalAlign: -2 }} /> {L('Constructor de presupuesto con IA', 'AI budget builder')}:</b>{' '}
        {L('Restaurantes ya pasó su límite. Súbelo a $700 y baja Transporte a $450 para no tocar tu meta de ahorro de $600.', 'Restaurants is already over. Raise it to $700 and lower Transport to $450 to keep your $600 savings goal.')}
        <div className="px-btns"><span className="px-btn dk">{L('Aceptar', 'Accept')}</span><span className="px-btn">{L('Ajustar monto', 'Adjust')}</span><span className="px-btn">{L('Descartar', 'Dismiss')}</span></div>
      </div>
    </>
  );
}

function AskAI({ language }) {
  const L = (es, en) => tr(language, es, en);
  const data = [[L('Vivienda', 'Housing'), 92], [L('Mercado', 'Groceries'), 70], [L('Restaurantes', 'Restaurants'), 58], [L('Transporte', 'Transport'), 34], [L('Suscripciones', 'Subscriptions'), 20]];
  return (
    <>
      <p className="px-h">{L('Pregúntale a la IA', 'Ask the AI')}</p>
      <p className="px-sub">{L('Preguntas libres sobre tus números; responde con el gráfico que corresponde.', 'Ask anything about your numbers; it answers with the right chart.')}</p>
      <div className="px-q"><AutoAwesomeIcon style={{ fontSize: 14, color: GOLD }} />{L('¿En qué gasté más en lo que va del año?', 'What did I spend the most on this year?')}</div>
      <div className="px-card">
        <div className="px-bars">
          {data.map(([n, h], i) => <div key={n}><i className={i === 2 ? 'hl' : ''} style={{ height: h + '%' }} /></div>)}
        </div>
        <div className="px-bl">{data.map(([n]) => <span key={n}>{n}</span>)}</div>
      </div>
      <div className="px-ai">
        {L('Vivienda es tu mayor gasto, pero lo que más creció fue ', 'Housing is your biggest expense, but what grew the most was ')}
        <b>{L('Restaurantes: +62% desde abril', 'Restaurants: +62% since April')}</b>.
        {L(' Además tienes 3 suscripciones que no usas hace meses: $147 al mes.', ' You also have 3 subscriptions you haven’t used in months: $147 a month.')}
      </div>
    </>
  );
}

function WhatsAppScreen({ language }) {
  const L = (es, en) => tr(language, es, en);
  return (
    <div>
      <div className="px-wah"><WhatsAppIcon style={{ fontSize: 18 }} />PCM</div>
      <div className="px-wa">
        <div className="px-msg me">
          <div className="px-rcpt">{L('BOLETA DE VENTA', 'RECEIPT')}<br />{L('Veterinaria Mister Pet', 'Mister Pet Vet')}<br /><b>$312.08</b></div>
          <small>5:59 p.m. ✓✓</small>
        </div>
        <div className="px-msg">
          {L('Leí el comprobante: ', 'Receipt read: ')}<b>{L('Mascotas', 'Pets')}</b>. {L('Gasto de $312.08 registrado en Visa Oro.', '$312.08 expense recorded on Visa Oro.')}<br />
          ⚠️ {L('Estás cerca de tu límite de Mascotas: te quedan ', 'You are close to your Pets limit: ')}<b>$17.92</b>{L(' para el resto del mes.', ' left for the rest of the month.')}
          <small>6:00 p.m.</small>
        </div>
        <div className="px-msg me">🎤 {L('Nota de voz · "almuerzo 45 con la tarjeta"', 'Voice note · "lunch 45 on the card"')}<small>6:01 p.m. ✓✓</small></div>
        <div className="px-msg">{L('Listo: Restaurantes, $45.00, Visa Oro.', 'Done: Restaurants, $45.00, Visa Oro.')}<small>6:01 p.m.</small></div>
        <div className="px-msg me">{L('¿cuánto llevo gastado en mercado este mes?', 'how much have I spent on groceries this month?')}<small>6:02 p.m. ✓✓</small></div>
        <div className="px-msg">{L('Llevas ', 'You’ve spent ')}<b>$1,180</b>{L(' de $1,400 en Mercado (84%). Te quedan $220 para 12 días.', ' of $1,400 on Groceries (84%). $220 left for 12 days.')}<small>6:02 p.m.</small></div>
      </div>
    </div>
  );
}

const SCREENS = [
  { key: 'dashboard', es: 'Tablero', en: 'Dashboard', C: Dashboard },
  { key: 'calendar', es: 'Calendario', en: 'Calendar', C: Calendar },
  { key: 'revision', es: 'Importar estados de cuenta', en: 'Import statements', C: Importer },
  { key: 'budgets', es: 'Presupuesto', en: 'Budget', C: Budget },
  { key: 'reports', es: 'Pregúntale a la IA', en: 'Ask the AI', C: AskAI },
  { key: 'whatsapp', es: 'WhatsApp y voz', en: 'WhatsApp & voice', C: WhatsAppScreen },
];

export default function AppShowcase({ language = 'es', light = false, start = 0 }) {
  const [i, setI] = useState(start);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % SCREENS.length), 7000);
    return () => clearInterval(id);
  }, [paused]);
  const s = SCREENS[i];
  const Screen = s.C;
  return (
    <div className={'px-wrap' + (light ? ' px-light' : '')} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <style>{CSS}</style>
      <div className="px-tabs" role="tablist">
        {SCREENS.map((x, n) => (
          <button key={x.key} type="button" role="tab" aria-selected={n === i} className={'px-tab' + (n === i ? ' on' : '')} onClick={() => { setI(n); setPaused(true); }}>
            {tr(language, x.es, x.en)}
          </button>
        ))}
      </div>
      <div className="px-win">
        <div className="px-bar"><span className="px-dots"><i /><i /><i /></span><span className="px-url">{s.key === 'whatsapp' ? 'WhatsApp · PCM' : 'pcm.darwinoptima.com/' + s.key}</span></div>
        {s.key === 'whatsapp' ? (
          <div key={s.key} className="px-fade"><Screen language={language} /></div>
        ) : (
          <div className="px-app">
            <Sidebar language={language} active={s.key} />
            <div key={s.key} className="px-main px-fade"><Screen language={language} /></div>
          </div>
        )}
      </div>
      <div className="px-sm" style={{ marginTop: 8, color: light ? '#6B6B6B' : 'rgba(255,255,255,.7)' }}>
        {tr(language, 'Pantallas reales de PCM con datos de ejemplo.', 'Real PCM screens with sample data.')}
      </div>
    </div>
  );
}

// Todo lo que hace PCM hoy, agrupado igual que el menú de la app.
export function PcmFeaturesGrid({ language = 'es' }) {
  const L = (es, en) => tr(language, es, en);
  const NEW = <span className="pxf-new">{L('Nuevo', 'New')}</span>;
  const groups = [
    [DashboardIcon, L('Cómo voy', 'How am I doing'), [
      <><b>{L('Tablero', 'Dashboard')}:</b> {L('saldos y deudas en moneda nacional y en dólares, y el aviso de cada tarjeta por vencer con dos caminos: pagar el 100% o financiar, con el costo de interés a la vista.', 'balances and debts in local currency and dollars, plus a heads-up for every card about to fall due with two paths: pay 100% or finance it, with the interest cost in plain sight.')}</>,
      <><b>{L('Calendario de flujo de caja', 'Cash-flow calendar')}:</b> {L('ingresos, gastos y saldo de fin de día, con tus recurrentes proyectados. Ves el día más ajustado con semanas de anticipación.', 'income, expenses and end-of-day balance with your recurring items projected. You see the tightest day weeks ahead.')}</>,
      <><b>{L('Informes', 'Reports')}:</b> {L('evolución mes a mes, gasto por categoría y filtros por año.', 'month-by-month trends, spending by category and yearly filters.')}</>,
    ]],
    [AccountBalanceWalletIcon, L('Mi dinero', 'My money'), [
      <><b>{L('Cuentas', 'Accounts')}:</b> {L('bancos y efectivo, con los últimos dígitos de cada cuenta. Te avisa si dos cuentas parecen la misma y te deja unirlas.', 'banks and cash with each account’s last digits. It warns you when two accounts look like the same one and lets you merge them.')} {NEW}</>,
      <><b>{L('Deuda', 'Debt')}:</b> {L('tarjetas y préstamos con entidad, fecha de corte, día de cierre y pago mensual.', 'cards and loans with lender, statement date, closing day and monthly payment.')}</>,
      <><b>{L('Dos monedas', 'Two currencies')}:</b> {L('moneda nacional y dólares por separado, con tipo de cambio y conversión en cada movimiento.', 'local currency and dollars side by side, with exchange rate and conversion on every transaction.')}</>,
    ]],
    [RuleIcon, L('Movimientos', 'Activity'), [
      <><b>{L('Importa tus estados de cuenta', 'Import your statements')}:</b> {L('PDF, CSV o Excel. La IA lee y clasifica cada movimiento, y reconoce pagos de tarjeta y cambios de moneda para unirlos solos.', 'PDF, CSV or Excel. AI reads and classifies every line, and recognizes card payments and FX exchanges to match them on its own.')} {NEW}</>,
      <><b>{L('Revisión pendiente', 'Pending review')}:</b> {L('nada cuenta hasta que lo confirmas. Detecta duplicados y te deja crear una cuenta o deuda sin salir de la pantalla.', 'nothing counts until you confirm it. It flags duplicates and lets you create an account or debt without leaving the screen.')} {NEW}</>,
      <><b>{L('Conciliación', 'Reconciliation')}:</b> {L('cuadra tus cuentas contra el banco, con ayuda de IA.', 'match your accounts against the bank, with AI help.')}</>,
      <><b>{L('WhatsApp y voz', 'WhatsApp & voice')}:</b> {L('manda la foto de la boleta, una nota de voz o un mensaje, y queda registrado.', 'send a photo of the receipt, a voice note or a message, and it’s recorded.')}</>,
    ]],
    [PieChartIcon, L('Planificación', 'Planning'), [
      <><b>{L('Presupuestos', 'Budgets')}:</b> {L('semáforo por categoría, gastado contra presupuestado, lo que queda y los días del mes.', 'traffic light by category, spent vs. budgeted, what’s left and the days in the month.')}</>,
      <><b>{L('Constructor de presupuesto con IA', 'AI budget builder')}:</b> {L('te sugiere cuánto gastar por categoría y qué recortar; aceptas, ajustas o descartas cada sugerencia. Incluye meta de ahorro.', 'suggests how much to spend per category and what to cut; accept, adjust or dismiss each suggestion. Includes a savings goal.')} {NEW}</>,
      <><b>{L('Recurrentes y categorías', 'Recurring & categories')}:</b> {L('sueldos, alquiler y suscripciones se proyectan solos; marca movimientos como recurrentes en masa.', 'salary, rent and subscriptions project themselves; mark transactions as recurring in bulk.')}</>,
    ]],
    [AutoAwesomeIcon, L('Inteligencia artificial', 'Artificial intelligence'), [
      <><b>{L('Pregúntale a la IA', 'Ask the AI')}:</b> {L('preguntas libres sobre tus finanzas, respondidas con gráficos de torta, líneas o barras.', 'ask anything about your finances, answered with pie, line or bar charts.')} {NEW}</>,
      <><b>{L('Auto-categorización y alertas', 'Auto-categorization & alerts')}:</b> {L('clasifica tus gastos y te avisa antes de pasarte del presupuesto.', 'classifies your spending and warns you before you go over budget.')}</>,
      <><b>{L('Ayuda dentro de la app', 'In-app help')}:</b> {L('manual y asistente con IA en cada pantalla.', 'manual and AI assistant on every screen.')}</>,
    ]],
    [CalendarMonthIcon, L('Asesoría humana', 'Human advice'), [
      <><b>{L('Expertos financieros', 'Financial experts')}:</b> {L('diagnóstico, manejo de deuda, presupuesto e inversiones con una persona.', 'diagnosis, debt management, budgeting and investments with a real person.')}</>,
      <><b>{L('Agenda tu consulta', 'Book a session')}:</b> {L('eliges el horario dentro de PCM y recibes la confirmación.', 'pick a time inside PCM and get a confirmation.')}</>,
      <><b>{L('En español o inglés', 'In Spanish or English')}:</b> {L('toda la app, con prueba gratis de 14 días.', 'the whole app, with a 14-day free trial.')}</>,
    ]],
  ];
  return (
    <div className="pxf px-wrap">
      <style>{CSS}</style>
      <div className="pxf-grid">
        {groups.map(([Icon, title, items]) => (
          <div className="pxf-card" key={title}>
            <h3><Icon fontSize="small" />{title}</h3>
            <ul>{items.map((it, n) => <li key={n}>{it}</li>)}</ul>
          </div>
        ))}
      </div>
    </div>
  );
}
